"use strict";

exports.__esModule = true;
var _createMetricFieldScale = require("./createMetricFieldScale");
Object.keys(_createMetricFieldScale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createMetricFieldScale[key]) return;
  exports[key] = _createMetricFieldScale[key];
});
var _flattenMetricResponse = require("./flattenMetricResponse");
Object.keys(_flattenMetricResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _flattenMetricResponse[key]) return;
  exports[key] = _flattenMetricResponse[key];
});